module.exports = __webpack_public_path__ + "img/web-search-engine.6fca164a.svg";